import { Link } from "react-router-dom"

const services = [
  // {
  //   name: 'SaaS Development',
  //   description: 'Custom software solutions tailored to your business needs with scalable architecture and modern technologies.',
  //   image: '/images/undraw_modern-design_yur1.svg',
  //   icon: (
  //     <svg className="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
  //     </svg>
  //   ),
  // },
  // {
  //   name: 'Email Campaigns',
  //   description: 'Targeted email marketing strategies that convert, with A/B testing and detailed analytics.',
  //   icon: (
  //     <svg className="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  //     </svg>
  //   ),
  // },
  // {
  //   name: 'SEO Strategy',
  //   description: 'Comprehensive search engine optimization to improve your visibility and organic traffic.',
  //   icon: (
  //     <svg className="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  //     </svg>
  //   ),
  // },
  {
    name: 'Google & Facebook Ads',
    description: 'Data-driven paid advertising campaigns that maximize ROI and customer acquisition.',
    url: '/google-facebook-ads',
    icon: (
      <svg className="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    ),
  },
  {
    name: 'Social Media Campaigns',
    description: 'Engaging content and strategic campaigns across all major social platforms.',
    url: '/social-media-campaigns',
    icon: (
      <svg className="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
      </svg>
    ),
  },
  {
    name: 'Analytics & Reporting',
    description: 'Comprehensive tracking and reporting to measure success and optimize performance.',
    url: '/analytics-reporting',
    icon: (
      <svg className="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
]

const Services = () => {
  return (
    <div id="services" className="bg-gray-50 py-12 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Services</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Digital Marketing & Saas Development Solutions
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            We offer end-to-end digital marketing services to help your business grow online.
          </p>
        </div>

        <div className="mt-20">
          <div className="flex">
            <div className="basis-3/5">
              <h3 className="text-5xl font-bold text-gray-900">
                SaaS Development
              </h3>
              <h4 className="text-xl font-semibold text-primary mt-2">
                Build Scalable, Secure & Cutting-Edge SaaS Solutions
              </h4>
              <p className="mt-2 text-base text-gray-500 mb-5">
                Looking for a reliable SaaS development partner? We design, build, and optimize high-performance SaaS platforms tailored to your business needs.
              </p>
              <ul className="mb-5">
                <li className="mt-2 text-base text-gray-500">✅ Custom SaaS Development - From MVP to enterprise-grade solutions</li>
                <li className="mt-2 text-base text-gray-500">✅ Cloud & DevOps Integration - Seamless, secure, and scalable</li>
                <li className="mt-2 text-base text-gray-500">✅ UI/UX-Centric Design - Intuitive interfaces that users love</li>
                <li className="mt-2 text-base text-gray-500">✅ Ongoing Support & Optimization - Keep your SaaS ahead of the curve</li>
              </ul>
              {/*<h4 className="text-xl font-semibold text-gray-700 mt-2 mb-5">Why Choose Us?</h4>
               <ul className="mb-5">
                <li className="mt-2 text-base text-gray-500">✔ Expert SaaS developers with proven success</li>
                <li className="mt-2 text-base text-gray-500">✔ Faster time-to-market without compromising quality</li>
                <li className="mt-2 text-base text-gray-500">✔ Transparent pricing & agile development</li>
              </ul>
              <p className="mb-2">Let's turn your vision into a powerful SaaS product.</p> */}
              <p className="font-bold text-black">Get a free consultation today!</p>
              <div className="mt-5">
                <Link
                  to="/saas-development"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-700"
                >
                  Learn More
                </Link>
              </div>
            </div>
            <div className="basis-2/5">
              <img src="/images/themarketingfeeds.com - from ideas to saas product.png" alt="SaaS Development" className="w-full h-96" />
            </div>
          </div>
        </div>

        <div className="mt-28">
          <div className="flex space-x-20">
            <div className="basis-2/5">
              <img src="/images/themarketingfeeds..com - email campaigns for your business.png" alt="Email Campaigns" className="w-full h-96" />
            </div>
            <div className="basis-3/5">
              <h3 className="text-5xl font-bold text-gray-900">
                Email Marketing
              </h3>
              <h4 className="text-xl font-semibold text-primary mt-2">
                Drive Engagement & Boost Conversions
              </h4>
              <p className="mt-2 text-base text-gray-500 mb-5">
                Our email marketing services are designed to help you connect with your audience, nurture leads, and drive sales through targeted campaigns.
              </p>
              <ul className="mb-5">
                <li className="mt-2 text-base text-gray-500">✅ Custom Email Templates - Engaging designs that convert</li>
                <li className="mt-2 text-base text-gray-500">✅ List Management - Grow and segment your audience effectively</li>
                <li className="mt-2 text-base text-gray-500">✅ A/B Testing - Optimize your campaigns for maximum impact</li>
                <li className="mt-2 text-base text-gray-500">✅ Analytics & Reporting - Measure success and refine strategies</li>
              </ul>
              <p className="font-bold text-black">Get a free consultation today!</p>
              <div className="mt-5">
                <Link
                  to="/email-marketing"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-700"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-28">
          <div className="flex space-x-20">
            <div className="basis-3/5">
              <h3 className="text-5xl font-bold text-gray-900">
                SEO Strategy
              </h3>
              <h4 className="text-xl font-semibold text-primary mt-2">
                Improve Your Visibility & Drive Organic Traffic
              </h4>
              <p className="mt-2 text-base text-gray-500 mb-5">
                Our SEO services are designed to help you improve your website's visibility on search engines, attract more organic traffic, and convert visitors into customers.
              </p>
              <ul className="mb-5">
                <li className="mt-2 text-base text-gray-500">✅ Keyword Research - Identify the right keywords to target</li>
                <li className="mt-2 text-base text-gray-500">✅ On-Page Optimization - Optimize your website's content and structure</li>
                <li className="mt-2 text-base text-gray-500">✅ Link Building - Acquire high-quality backlinks to boost authority</li>
                <li className="mt-2 text-base text-gray-500">✅ Local SEO - Optimize for local searches and Google My Business</li>
              </ul>
              <p className="font-bold text-black">Get a free consultation today!</p>
              <div className="mt-5">
                <Link
                  to="/seo-strategy"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-700"
                >
                  Learn More
                </Link>
              </div>
            </div>
            <div className="basis-2/5">
              <img src="/images/themarketingfeeds.com - seo strategy.png" alt="Email Campaigns" className="w-full h-96" />
            </div>
          </div>
        </div>

        <div className="mt-20">
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => (
              <div key={service.name} className="pt-6">
                <div className="flow-root bg-white rounded-lg px-6 pb-8 h-full shadow">
                  <div className="-mt-6">
                    <div>
                      <span className="inline-flex items-center justify-center p-3 bg-primary-500 rounded-md shadow-lg">
                        {service.icon}
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">{service.name}</h3>
                    <p className="mt-5 text-base text-gray-500">
                      {service.description}
                    </p>
                    <div className="mt-6">
                      <Link
                        to={service.url}
                        className="text-base font-medium text-primary hover:text-primary-700"
                      >
                        Learn More <span aria-hidden="true">&rarr;</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Services